<template>
  <!-- Main sidebar -->
  <div class="sidebar sidebar-dark sidebar-main sidebar-expand-md">
    <!-- Sidebar mobile toggler -->
    <div class="sidebar-mobile-toggler text-center">
      <router-link
        to="#"
        class="sidebar-mobile-main-toggle"
      >
        <i class="icon-arrow-left8" />
      </router-link>
      {{ $t("Goship") }}
      <router-link
        to="#"
        class="sidebar-mobile-expand"
      >
        <i class="icon-screen-full" />
        <i class="icon-screen-normal" />
      </router-link>
    </div>
    <!-- /sidebar mobile toggler -->

    <!-- Sidebar content -->
    <div class="sidebar-content">
      <!-- Main navigation -->
      <div class="sidebar-user">
        <div class="card-body pb-2">
          <div class="media">
            <div class="mr-1">
              <router-link :to="{ name: 't.a.home' }">
                <i
                  class="
                    fa-regular fa-circle-arrow-left
                    text-white
                    align-middle
                    mr-2
                  "
                  style="font-size: 1.5em"
                />
              </router-link>
              <img
                v-if="tenant.logo"
                :src="tenant.logo"
                width="38"
                height="38"
                class="rounded-circle"
                alt
              >
              <span
                class="icon-store-custom mr-2 mt-1"
                style="line-height: 0px"
                v-else
              >
                <i
                  class="fas fa-store"
                  style="margin-top: 0.425rem"
                />
              </span>
            </div>
            <div class="media-body">
              <div class="media-title font-weight-semibold">
                {{ tenant.name }}
              </div>
              <div class="font-size-xs text-success">
                <i class="fa-solid fa-circle-check mr-1" />{{ $t("Online") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card card-sidebar-mobile">
        <ul
          class="nav nav-sidebar"
          data-nav-type="accordion"
        >
          <!-- Main -->
          <li class="nav-item">
            <router-link
              :to="{ name: 't.a.account-setting.shippingcredit' }"
              class="nav-link"
            >
              <i class="fa-solid fa-wallet" /><span>{{ $t("Shipping Credit") }}</span>
            </router-link>
            <router-link
              :to="{ name: 't.a.account-setting.smscredit' }"
              class="nav-link"
            >
              <i class="fa-solid fa-comment-sms" /><span>{{ $t("SMS Credit") }}</span>
            </router-link>
            <router-link
              v-if="features.includes('feature-slip-verification')"
              :to="{ name: 't.a.service-credit.index' }"
              class="nav-link"
            >
              <i class="fa-solid fa-sack-dollar" /><span>{{ $t("Service Credit") }}</span>
            </router-link>
            <router-link
              :to="{ name: 't.a.premium.subscriptions' }"
              class="nav-link"
            >
              <i class="fas fa-envelope-open-dollar" /><span>{{ $t("Premium Subscriptions") }}</span>
            </router-link>
            <router-link
              :to="{ name: 't.a.purchase-apps.index' }"
              class="nav-link"
            >
              <i class="fas fa-grid-2-plus" /><span>{{ $t("Apps") }}</span>
            </router-link>
            <!-- <router-link
              v-if="$store.state.user.planGroup == 'gosell'"
              :to="{ name: 't.a.account-setting.billing' }"
              class="nav-link"
            >
              <i class="fas fa-receipt" /><span>{{ $t("Billing") }}</span>
            </router-link> -->
          </li>
          <!-- /page kits -->
        </ul>
      </div>
      <!-- /main navigation -->
    </div>
    <!-- /sidebar content -->
  </div>
  <!-- /main sidebar -->
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "LeftMenuAccountSetting",
  data() {
    return {
      tenant: JSON.parse(Cookies.get('tenant')),
      features: JSON.parse(Cookies.get('features'))
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
<style scoped>
.actives.router-link-active {
  background: #1f88e5;
}
.icon-store-custom {
  width: 34px;
  height: 34px;
  line-height: 34px;
  background: #ecf0f1;
  border-radius: 100%;
}
.sidebar-xs .media {
  text-align: center;
}

.sidebar-xs .media a i {
  margin-left: 12px;
  margin-bottom: 12px;
}

.sidebar-xs .media .icon-store-custom {
  margin-left: 7px;
}
.sidebar-xs .media .icon-store-custom i {
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/LeftMenuAccountSetting.vue